import script from "./StudentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentCard.vue?vue&type=script&setup=true&lang=js"

import "./StudentCard.vue?vue&type=style&index=0&id=5241264e&scope=true&lang=css"

const __exports__ = script;

export default __exports__